import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import authHeader from "./authHeader";
import { apiInstance } from "./axiosApi";

export const getAllSubTopic = createAsyncThunk(
  "admin/allSubTopic",
  async ({ page, limit, searchData }, { rejectWithValue }) => {
    try {
      let url = `/sub-topic/all?page=${page}&limit=${limit}`;
      if (searchData) {
        url += `&search=${searchData}`;
      }
      const response = await apiInstance.get(url, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getSingleSubTopic = createAsyncThunk(
  "admin/singleSubTopic",
  async (SubjectId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`/sub-topic/${SubjectId}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const addSubTopic = createAsyncThunk(
  "admin/addSubTopic",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/sub-topic/add`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const editSubTopic = createAsyncThunk(
  "admin/editSubTopic",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/sub-topic/edit`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteSubTopic = createAsyncThunk(
  "admin/deleteSubTopic",
  async (selectedId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.delete(
        `/sub-topic/delete/${selectedId}`,
        {
          headers: authHeader(),
        }
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const initialState = {
  subTopicLoading: false,
};

const subTopicSlice = createSlice({
  name: "subTopicSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllSubTopic.fulfilled, (state, action) => {
      state.subTopicData = action.payload.data;
      state.subTopicLoading = false;
    });
    builder.addCase(getSingleSubTopic.fulfilled, (state, action) => {
      state.singleSubTopicData = action.payload.data;
    });
  },
});
export default subTopicSlice.reducer;
